import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import c from './assets/sass/result.module.scss'

export const Result = ({ type, onPlayAgain }) => {
    const { t } = useTranslation()
    const getContent = () => {
        if (type === 'win') {
            return (
                <div className={c.row}>
                    <span className={c.title}>{t('mines.result.win')}</span>
                    <span className={c.subTitle}>
                        {t('mines.result.winSubtitle')}
                    </span>
                </div>
            )
        }

        return (
            <div className={c.row}>
                <span className={c.title}>{t('mines.result.lose')}</span>
                <span className={c.subTitle}>
                    {t('mines.result.loseSubtitle')}
                </span>
            </div>
        )
    }
    return (
        <div
            className={cn(c.component, {
                [c.win]: type === 'win',
                [c.lose]: type === 'lose',
            })}
        >
            {getContent()}
        </div>
    )
}
